export const useFeatureFlag = () => {
  const isTrialVersion = import.meta.env.VITE_IS_TRIAL_VERSION;
  return { isTrialVersion };
};
